<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import { useRouter } from 'vue-router'
import { Icon } from '@iconify/vue'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import _ from 'lodash'

import moment from 'moment'
import ListingDetail from '@/modules/realestate/views/ListingDetail.vue'
import {
  FlashOfferCreateActionTypes,
  useFlashOfferCreateStore
} from '@/modules/flashoffer/stores/flashoffer.create.store.ts'
import { numHelper } from '@/utils/numHelper.ts'
import { useToast } from 'primevue/usetoast'
import { useTransactionStore } from '@/modules/transaction/stores/transaction.list.store.ts'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import TransactionAPI from '@/modules/transaction/constants/transaction.api.uri.const.ts'
import { FlashOfferAPI } from '../constants/flashoffer.api.uri.const'
import { schemaCreateFO } from '../helper/validationFOSchema'
import { yupResolver } from '@primevue/forms/resolvers/yup'
import CSInputText from '@/onenetwork/components/form/CSInputText.vue'
import { FO_STATUS_OPTIONS, initialValuesCreateFO, parseFormDataFO } from '../helper/form'
import { FO_STATUS } from '../helper/table'
import { useConfirm } from 'primevue'
import AllowPerm from '@/onenetwork/components/perms/AllowPerm.vue'
import CsButton from '@/components/ui/button/CsButton.vue'


const router = useRouter()
const flashOfferCreateStore = useFlashOfferCreateStore()


const pageTabs = computed(() => {
  return flashOfferCreateStore.tabs
})
const displayTabContent = computed(() => {
  return flashOfferCreateStore.tabs?.find(tab => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return flashOfferCreateStore.tableConfig
})
const filter = computed(() => {
  return flashOfferCreateStore.filter
})
const loading = computed(() => {
  return flashOfferCreateStore.action_type == FlashOfferCreateActionTypes.FETCHING
})
const page = computed(() => {
  return flashOfferCreateStore.page
})
const pageSize = computed(() => {
  return flashOfferCreateStore.pageSize
})
const dataSource: any = computed(() => {
  return flashOfferCreateStore.data
})

const canEditItem = computed(() => {
  return true
})

const handleChangeTab = (tab: any) => {

  flashOfferCreateStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {

  flashOfferCreateStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  flashOfferCreateStore.closeAllTab()
}

const handleChangePage = (page: number) => {

  flashOfferCreateStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  flashOfferCreateStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {
console.log(filter, 'filter');

  filter.map((item: any) => {
    if (item.key === 'province_id') {
      formRef.value?.setFieldValue('province_id', item.value[0]?.id || null)
      formRef.value?.setFieldValue('ward_id', null)
      //reset error
    }
    if (item.key === 'ward_id') {
      formRef.value?.setFieldValue('ward_id', item.value[0]?.id)
      //reset error
    }
    if (item.key === 'keyword') {
      formRef.value?.setFieldValue('keyword', item.value)
      //reset error
    }
  })
  flashOfferCreateStore.setFilter(filter)
}

const handleGotoDetail = (e: MouseEvent, item: any) => {

  // router.push({ name: 'flash-offer-detail', params: { id: item.id } })
  flashOfferCreateStore.newTab({id: item.id, label: `#${item.id} - ${item.title}`, active: true})
}

const handleChangeSelectedRow = (ids: Array<string|number>) => {

  const idArray = flashOfferCreateStore.idArray;
  formRef.value?.setFieldValue('real_estate_ids', ids.length > 0 ? ids : idArray)
  flashOfferCreateStore.setSelectedIds(ids)
}

const handleSort = (field: string, direction: string) => {

  flashOfferCreateStore.toggleSort(field, direction)
}

const requestFetchRealEstateList = _.debounce(async () => {
  try{
    const res = await flashOfferCreateStore.fetchRealEstateList()
  } catch (e) {

  }
}, 500)


const toast = useToast();

const initialValues = ref(initialValuesCreateFO);

const resolver = yupResolver(schemaCreateFO);

const startedAt = ref(initialValues.value.started_at);
const endedAt = ref(initialValues.value.ended_at);

const formRef = ref<any>(null);
const loadingSubmit = ref<boolean>(false);
const confirm = useConfirm();

const requestCreateFO = async (data: any) => {
  try{
    loadingSubmit.value = true;
    const res = await APIClient.post(FlashOfferAPI.flashoffer.create, data);
    loadingSubmit.value = false;
    console.log(res, 'res');
    if (res.data.code === 200) {
      flashOfferCreateStore.resetFilter();
      toast.add({ severity: 'success', summary: 'Success', detail: 'Tạo Flash offer thành công', life: 3000 });
      flashOfferCreateStore.resetFilter();
      formRef.value?.reset();
      router.push({ name: 'flash-offer-list' })
    }
  } catch (e: any) {
    loadingSubmit.value = false;
    const error = e.response.data.message || 'Đã có lỗi xảy ra';
    toast.add({ severity: 'error', summary: 'Rejected', detail: error, life: 3000 });
  }
}


const onFormSubmit = ({valid, values}: any) => {
  console.log(parseFormDataFO(values));
  if (!valid) {
    return;
  }
  confirm.require({
    message: 'Bạn có muốn tạo Flash Offer?',
    header: 'Xác nhận',
    // icon: 'pi pi-exclamation-triangle',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'Đồng ý'
    },
    accept: () => {
      const formData = parseFormDataFO(values);
      requestCreateFO(formData);

    },
    reject: () => {
      toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }
  });
};

watch(startedAt, (newVal) => {
  initialValues.value.started_at = newVal;
  formRef.value?.setFieldValue('started_at', moment(newVal).format('YYYY-MM-DD HH:mm:ss'));
  endedAt.value = moment(newVal).toDate();
});

watch(endedAt, (newVal) => {
  initialValues.value.ended_at = newVal;
  formRef.value?.setFieldValue('ended_at', moment(newVal).format('YYYY-MM-DD HH:mm:ss'));
});


watch(()=> flashOfferCreateStore.uuid, (newVal, oldVal) => {
  requestFetchRealEstateList()
})

const handleSubmit = () => {
  console.log('handleSubmit', formRef.value.values);
  formRef.value?.submit();
}

onMounted(() => {
  // if(flashOfferCreateStore.action_type === FlashOfferCreateActionTypes.PENDING) requestFetchRealEstateList()
  requestFetchRealEstateList()
})/**/

onBeforeUnmount(() => {
  flashOfferCreateStore.resetFilter();
  formRef.value?.reset();
})


</script>

<template>
  <dashboard-layout currentRoute="flash-offer/list" page-title="Quản lý Flash Offer • Tạo mới" :tabs="pageTabs" :tabsEvent="{
    close: handleCloseTab,
    select: handleChangeTab,
    closeAll: handleCloseAllTab
  }">
    <template v-if="displayTabContent == 'list'">
      <Form
        v-slot="$form"
        ref="formRef"
        :initial-values="initialValues"
        :validate-on-submit="true"
        :resolver="resolver"
        @submit="onFormSubmit"
        >
        <Panel class="mb-5" header="Cài đặt Flash Offer">
          <div class="flex flex-col md:flex-row items-start gap-x-10 gap-y-5">
            <InputText name="province_id" hidden type="text" class="form-control"/>
            <InputText name="ward_id" hidden type="text" class="form-control"/>
            <InputText name="real_estate_ids" hidden type="text" class="form-control"/>
            <InputText name="keyword" hidden type="text" class="form-control"/>
            <div class="flex flex-col gap-1 min-w-[200px]">
              <label class="form-label">Thời gian bắt đầu</label>
              <div class="input">
                <DatePicker :manual-input="true" :min-date="new Date()" v-model="startedAt"  class="form-control w-full" show-time/>
                <InputText name="started_at" hidden type="text" class="form-control"/>
                <span class="italic text-[12px] text-red-500 mt-1" v-if="$form.started_at?.invalid">
                  {{ $form.started_at.error.message }}
                </span>
              </div>
            </div>
            <div class="flex flex-col gap-1 min-w-[200px]">
              <label class="form-label">Thời gian kết thúc</label>
              <div class="input">
                <DatePicker :manual-input="true" :min-date="startedAt" v-model="endedAt" class="form-control w-full" show-time/>
                <InputText name="ended_at" hidden type="text" class="form-control"/>
                <span class="italic text-[12px] text-red-500 mt-1" v-if="$form.ended_at?.invalid">
                  {{ $form.ended_at.error.message }}
                </span>
              </div>
            </div>
            <div class="flex flex-col gap-1 min-w-[320px]">
              <label class="form-label">Tiêu đề sự kiện</label>
              <div class="input">
                <CSInputText name="name" type="text" class="form-control w-full"/>
                <span class="italic text-[12px] text-red-500 mt-1" v-if="$form.name?.invalid">
                  {{ $form.name.error.message }}
                </span>
              </div>
            </div>
            <div class="flex flex-col gap-1 min-w-[200px]">
              <label class="form-label">Tiền cọc</label>
              <div class="input">
                <InputNumber name="deposit" class="form-control w-full" inputId="minmax-buttons" suffix=" đ" mode="decimal" locale="vi-VN" :min="0" :max="1000000000" fluid />
                <span class="font-italic text-[12px] text-red-500 mt-1">{{numHelper($form?.deposit?.value).numberToVietnameseText({unit: 'đồng'})}}</span>
                <span class="italic text-[12px] text-red-500 mt-1" v-if="$form.deposit?.invalid">
                  {{ $form.deposit.error.message }}
                </span>
              </div>
            </div>
            <div class="flex flex-col gap-1 min-w-[200px]">
              <label class="form-label">Trạng thái</label>
              <div class="input">
                <Select name="status" :options="FO_STATUS_OPTIONS"
                  optionLabel="label"
                  optionValue="code"
                  placeholder="Chọn trạng thái"
                  class="form-control w-full"/>
              </div>
            </div>

          </div>
        </Panel>
        <Panel class="mb-5" header="Danh sách sản phẩm mở bán">
          <filter-list
            :read-only="!canEditItem"
            :filter="filter"
            :errors="{
              province_id: $form?.province_id?.error?.message,
              ward_id: $form?.ward_id?.error?.message
            }"
            @update:filter="handleUpdateFilter"
            @reset:filter="flashOfferCreateStore.resetFilter"
          />
          <span class="italic text-[12px] text-red-500 mt-1" v-if="$form.real_estate_ids?.invalid">
            {{ $form.real_estate_ids.error.message }}
          </span>
          <data-table
            :loading="loading"
            :tableConfig="TableConfig"
            :displayConfig="false"
            :page-size="pageSize"
            :page="page"
            :total-page="dataSource?.totalPage || 0"
            :total-records="dataSource?.totalRecords || 0"
            :data="dataSource?.list || []"
            :row-action-buttons="[
              // { action: handleGotoDetail, css: 'btn btn-cs', label: 'Chi tiết', icon: 'iconamoon:edit-duotone' }
            ]"
            primaryField="id"
            @page-changed="handleChangePage"
            @pagesize-changed="handleChangePageSize"
            @toggle-visibility="flashOfferCreateStore.toggleColumnVisibility"
            @on-selected-row="handleChangeSelectedRow"
            @on-sort="handleSort"
          />
          <divider />
          <div class="flex justify-end">
            <AllowPerm perm="flash_offer.create_flash_offer" action="hide">
              <div class="flex flex-col gap-1 min-w-[120px]">
                <label class="form-label">&nbsp;</label>
                <CsButton
                  type="button"
                  customClass="!py-3 !px-5 !text-[14px]"
                  text="Tạo mới Flash Offer"
                  :loading="loadingSubmit"
                  :disabled="loadingSubmit"
                  @click="handleSubmit"
                />
              </div>
            </AllowPerm>
          </div>
        </Panel>
      </Form>
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <ListingDetail :id="tab.id" :key="tab.id"/>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
